import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['input', 'dropdown', 'list']
  static values = { url: String }

  connect() {
    this.abortController = null
    this.selectedIndex = -1
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown()
    }
  }

  async search() {
    const query = this.inputTarget.value.trim()

    if (query.length < 1) {
      this.hideDropdown()
      return
    }

    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()

    try {
      const response = await get(this.urlValue, {
        query: { q: query },
        signal: this.abortController.signal
      })

      if (response.ok) {
        const posts = await response.json
        this.showResults(posts)
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Search failed:', error)
      }
    }
  }

  showResults(posts) {
    this.selectedIndex = -1

    if (posts.length === 0) {
      this.hideDropdown()
      return
    }

    this.listTarget.innerHTML = posts.map((post, index) => `
      <button type="button"
              class="w-full px-3 py-2 text-left text-sm hover:bg-primary-soft cursor-pointer"
              data-action="click->slug-typeahead#select"
              data-slug="${post.slug}"
              data-index="${index}">
        <div class="font-medium text-text truncate">${post.title}</div>
        <div class="text-xs text-text-muted truncate">${post.slug}</div>
      </button>
    `).join('')

    this.dropdownTarget.classList.remove('hidden')
  }

  hideDropdown() {
    this.dropdownTarget.classList.add('hidden')
    this.selectedIndex = -1
  }

  select(event) {
    const slug = event.currentTarget.dataset.slug
    this.inputTarget.value = slug
    this.hideDropdown()
  }

  keydown(event) {
    if (this.dropdownTarget.classList.contains('hidden')) return

    const items = this.listTarget.querySelectorAll('button')
    if (items.length === 0) return

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1)
        this.highlightItem(items)
        break
      case 'ArrowUp':
        event.preventDefault()
        this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
        this.highlightItem(items)
        break
      case 'Enter':
        event.preventDefault()
        if (this.selectedIndex >= 0) {
          items[this.selectedIndex].click()
        }
        break
      case 'Escape':
        this.hideDropdown()
        break
    }
  }

  highlightItem(items) {
    items.forEach((item, index) => {
      if (index === this.selectedIndex) {
        item.classList.add('bg-primary-soft')
      } else {
        item.classList.remove('bg-primary-soft')
      }
    })
  }
}
